import { useObserver } from "mobx-react";
import React from "react";
import locale from "@bonliva-crm/locale";
import { Text } from "@components/formx";

export function EmployeeNumberInfo() {
  return useObserver(() => {
    return (
      <div>
        <div>
          <Text name="employeeNumber.employeeNumber" label={locale.EmployeeNumber} />
        </div>

        <div style={{ marginTop: 8 }}>
          <Text name="employeeNumber.employeeNumber2" label={locale.EmployeeNumber2} />
        </div>

        <div style={{ marginTop: 8 }}>
          <Text name="employeeNumber.employeeNumber3" label={locale.EmployeeNumber3} />
        </div>
      </div>
    );
  });
}
